import gql from 'graphql-tag';

export const CREATE_NOTE = gql`
	mutation createNoteMutation($input: CreateNoteInput!) {
		createNote(input: $input) {
			id
			description
			isAdminNote
			isImportant
			isPlanogramNote
			created
			creator {
				id
				username
			}
			modified
			modifier {
				id
				username
			}
		}
	}
`;

